<script>
export default {
  name: 'Share',
  data() {
    return {
      show: false,
    }
  },
  methods: {
    close() {
      this.show = false
    },
    trigger() {
      this.show = !this.show
    },
  },
  render() {
    return this.$scopedSlots.default({
      trigger: this.trigger,
      close: this.close,
      showItem: this.show,
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/js/shared/components/Share.vue